/* eslint-disable import/no-cycle */
import axios from 'axios';
import moment from 'moment';

import {
  CustomException,
  getIdToken,
  getListItemsCount,
  isResponseValid,
  throwSAPError,
  downloadExcel,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import { GET_BILLING_TABLE_DATA, SET_BILLING_TABLE_STATUS } from '../helpers/types';

const invalidResponseMsgText = i18n.t('orderScreenTranslations:INVALID_RESPONSE');

export const getBillingTableData = (
  skip,
  top,
  enqueueSnackbar = () => {},
  filterStr = ''
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner } = auth;
    dispatch({
      type: SET_BILLING_TABLE_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    const idToken = await getIdToken(dispatch, getState);

    let config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `PayerParty eq '${BusinessPartner}'`,
      },
    };
    if (filterStr !== '') {
      config = {
        ...config,
        params: {
          ...config.params,
          $filter: `PayerParty eq '${BusinessPartner}' and ${filterStr}`,
        },
      };
    }
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_PB2B_SRV/ZAE_C_CompleteBilling`;
      listCount = await getListItemsCount(config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
      });
      const response = await MainService.get('/ZAE_C_CompleteBilling', config).catch(throwSAPError);
      if (isResponseValid(response)) {
        const Data = response.data.d.results.map(r => ({
          ...r,
          BillingDocumentDate: moment(r.BillingDocumentDate).format('MMMM DD, YYYY'),
        }));

        dispatch({
          type: GET_BILLING_TABLE_DATA,
          payload: {
            data: Data,
            listCount,
          },
        });
      } else {
        throw new CustomException(i18n.t('billingScreenTranslations:INVALID_RESPONSE'));
      }
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('billingScreenTranslations:UNABLE_TO_LOAD_BILLING_DATA'), {
      variant: 'error',
    });

    dispatch({
      type: SET_BILLING_TABLE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('billingScreenTranslations:UNABLE_TO_LOAD_BILLING_DATA'),
      },
    });
  }
};

export const getAllBillingData = (skip, top, enqueueSnackbar = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner } = auth;
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `PayerParty eq '${BusinessPartner}'`,
      },
    };

    config.params = {
      ...config.params,
      $skip: skip,
    };

    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
    });
    const response = await MainService.get('/ZAE_C_CompleteBilling', config).catch(throwSAPError);
    if (isResponseValid(response)) {
      const Data = response.data.d.results.map(r => ({
        Id: r.BillingDocument,
        Status: r.OverallBillingStatusDesc,
        ShipToParty: r.CustomerName,
        NetAmount: `${r.TotalNetAmount} ${r.TransactionCurrency}`,
        TaxAmount: `${r.TotalTaxAmount} ${r.TransactionCurrency}`,
        TotalAmount: ` ${r.TotalAmount}  ${r.TransactionCurrency}`,
        InvoiceDate: moment(r.BillingDocumentDate).format('MMMM DD, YYYY'),
      }));
      Data.sort((a, b) => b.BillingDocument - a.BillingDocument);
      downloadExcel(Data, 'AllBillings.xlsx', 'Billings');
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: GET_BILLING_TABLE_DATA,
      payload: {
        isLoading: false,
        failText: i18n.t('orderScreenTranslations:UNABLE_TO_LOAD_ORDERS_DATA'),
      },
    });

    enqueueSnackbar(i18n.t('billingScreenTranslations:UNABLE_TO_LOAD_BILLING_DATA'), {
      variant: 'error',
    });
  }
};
